import { materialMoney } from '../../../utils/materialDisplay';
import { SUPPLY_ORDER_PRICE_TEXTS } from '../constants/supplyOrdersConstants';

/**
 * Formatea un precio o importe de la orden; sin valor muestra el texto de precio pendiente.
 * @param {number|string|null|undefined} value Precio o importe.
 * @returns {string} Importe formateado o "Precio pendiente".
 */
export const formatSupplyOrderPrice = (value) =>
  value == null ? SUPPLY_ORDER_PRICE_TEXTS.pendingPrice : materialMoney(value);
